import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { FieldType, FormlyModule } from '@ngx-formly/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { debounceTime, takeUntil, tap } from 'rxjs';
import { injectDestroy } from 'ngxtension/inject-destroy';
import { DateHelperService } from '../../services/date-helper.service';
import { InfoTooltipComponent } from '../info-tooltip.component';
import { parseInt } from 'lodash-es';

@Component({
  selector: 'formly-field-date-range-week',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    @if (!props.hideLabel) {
      <h3 class="mb-2">
        {{ props.label }}
        <app-info-tooltip [tooltip]="props.info"></app-info-tooltip>
      </h3>
    }
    @if (field.props.description) {
      <mat-hint class="inline-block mb-2">{{ field.props.description }}</mat-hint>
    }
    <div class="w-full block">
      @for (fieldItem of field.fieldGroup; track $index) {
        <formly-field [field]="fieldItem"></formly-field>
      }
    </div>
    @if (field.props.description) {
      <mat-hint>{{ field.props.description }}</mat-hint>
    }
  `,
  imports: [
    MatDatepickerModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    FormlyModule,
    InfoTooltipComponent,
  ],
})
export class FormlyFieldDateRangeWeekComponent extends FieldType implements OnInit {
  private destroy$ = injectDestroy();
  constructor() {
    super();
  }

  ngOnInit() {
    // in some cases it can be timestamp, convert to date
    if (this.field.formControl.value?.startDate != undefined && this.field.formControl.value?.endDate != undefined) {
      this.field.formControl.patchValue({
        startDate: new Date(this.field.formControl.value?.startDate),
        endDate: new Date(this.field.formControl.value?.endDate),
      });
    }

    this.field.formControl.valueChanges
      .pipe(
        takeUntil(this.destroy$),
        debounceTime(300),
        tap(() => {
          this.setStartAndEndDate();
        })
      )
      .subscribe();
  }

  setStartAndEndDate() {
    const weekValue = this.field.formControl.value?.week;
    if (weekValue) {
      const [year, weekNum] = weekValue.split('-W');

      // Get Monday (start) of the week
      const startDate = this.getDateOfISOWeek(parseInt(weekNum), parseInt(year));
      startDate.setHours(0, 0, 0, 0);

      // Get Sunday (end) of the week
      const endDate = new Date(startDate);
      endDate.setDate(startDate.getDate() + 6);
      endDate.setHours(23, 59, 59, 999);

      if (this.field.formControl.value.startDate != DateHelperService.toLocalISOString(startDate))
        this.field.formControl.patchValue(
          {
            startDate: DateHelperService.toLocalISOString(startDate),
            endDate: DateHelperService.toLocalISOString(endDate),
          },
          { emitEvent: true }
        );
    }
  }

  private getDateOfISOWeek(week: number, year: number): Date {
    const simple = new Date(year, 0, 1 + (week - 1) * 7);
    const dayOfWeek = simple.getDay();
    const ISOweekStart = simple;
    if (dayOfWeek <= 4) {
      ISOweekStart.setDate(simple.getDate() - simple.getDay() + 1);
    } else {
      ISOweekStart.setDate(simple.getDate() + 8 - simple.getDay());
    }
    return ISOweekStart;
  }
}
